import { gql } from '@apollo/client'
import { CHATBOT_QUICK_PROMPT_FIELDS } from './fragments/chatbot_quick_prompt'

export const CREATE_CHATBOT_QUICK_PROMPT = gql`
  ${CHATBOT_QUICK_PROMPT_FIELDS}
  mutation createChatbotQuickPrompt($title: String, $text: String) {
    createChatbotQuickPrompt(title: $title, text: $text) {
      ...ChatbotQuickPromptFields
    }
  }
`
